import { useState, useEffect } from 'react';

export default function usePersistedState<T>(defaultValue: T, key: string, storage = window.localStorage) {
  const tryGetCachedValue = (key: string, storage: Storage, defaultValue: T) => {
    try {
      let cachedValue = key ? storage.getItem(key) : null;
      if (!cachedValue) return defaultValue;
      try {
        return JSON.parse(cachedValue);
      } catch (err) {
        return cachedValue;
      }
    } catch (err) {
      return defaultValue;
    }
  };

  let [value, setValue] = useState<T>(() => {
    return tryGetCachedValue(key, storage, defaultValue);
  });

  useEffect(() => {
    setValue(tryGetCachedValue(key, storage, defaultValue));
  }, [key]);

  useEffect(() => {
    if (!key) return;
    let valueStr = typeof value === 'string' ? value : JSON.stringify(value);
    storage.setItem(key, valueStr);
  }, [key, value]);

  return [value, setValue] as [T, typeof setValue];
}
